import { useStaticQuery, graphql } from "gatsby";

export const ContentSEO = () => {
  return useStaticQuery(graphql`
    {
      allStrapiPage(filter: { name_: { eq: "INDUSTRIES-CASE_STUDIES" } }) {
        nodes {
          # seo
          seo {
            id
            title
            keywords {
              data{
                keywords
              }
            }
            description {
              data{
                description
              }
            }
          }
 
          locale
        }
        pageInfo {
          perPage
        }
      }
    }
  `);
};
